import {
  GET_UPDATE_STATUS,
  GET_UPDATE_STATUS_SUCCESS,
  GET_UPDATE_STATUS_FAILURE,
} from 'store/providerStatus/providerStatusAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const patientStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_UPDATE_STATUS:
      return { ...state, loading: true };
    case GET_UPDATE_STATUS_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_UPDATE_STATUS_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default patientStatusReducer;
